import { CurrencyPipe } from '@angular/common';
import { ApplicationConfig } from '@angular/core';

import { AssigneesFilterPipe } from '../pipes/assignees-filter.pipe';
import { EmailModuleItemSectionOrderPipe } from '../pipes/email-module-item-section-order.pipe';
import { EventDataSourceFilterPipe } from '../pipes/event-data-source-filter.pipe';
import { EventTriggerFilterPipe } from '../pipes/event-trigger-filter.pipe';
import { GiftBudgetLimitFilterPipe } from '../pipes/gift-budget-limit-filter.pipe';
import { PhonePipe } from '../pipes/phone.pipe';
import { SafeHtmlPipe } from '../pipes/safe-html.pipe';
import { ViewEventsFilterPipe } from '../pipes/view-events-filter.pipe';
import { ViewEventsSortPipe } from '../pipes/view-events-sort.pipe';

export const pipesProvider: ApplicationConfig['providers'] = [
	ViewEventsSortPipe,
	EventDataSourceFilterPipe,
	EventTriggerFilterPipe,
	ViewEventsFilterPipe,
	AssigneesFilterPipe,
	CurrencyPipe,
	GiftBudgetLimitFilterPipe,
	SafeHtmlPipe,
	EmailModuleItemSectionOrderPipe,
	PhonePipe,
];
